import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class ReportAdvisePluginService extends InspectionPluginService {
  constructor(protected apiService: ApiService, protected dataService: DataService, private inspectionFactory: InspectionFactoryService) {
    super(apiService, dataService, null, inspectionFactory);
  }

  public updateReports(inspectionId: string, pointId: string, pluginId: string, reports: any): Observable<any> {
    return this.update(inspectionId, pointId, pluginId, reports).pipe(
      map((res: InspectionPlugin) => {
        this.dataService.setChangedPoint(pointId);
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  public deletePlugin(inspectionId: string, pointId: string, pluginId: string) {
    return super.deletePlugin(inspectionId, pointId, pluginId).pipe(
      map((success) => {
        return success;
      })
    );
  }

  private update(inspectionId: string, pointId: string, pluginId: string, reports: any): Observable<any> {
    return this.inspectionFactory.updatePluginConfig(inspectionId, pointId, pluginId, reports, 'ReportAdviseRemarks').pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
